import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_CHECK, AUTH_ERROR } from 'admin-on-rest'
import { jsonApiHttpClient } from './fetch'

import constants from '../utils/constants'
import compareScopes from './compareScopes'

const APP_PERMISSIONS = ['root']

export default (type, params) => {
  if (type === AUTH_LOGIN) {
    const { username, password } = params

    var data = JSON.stringify({
      identifier: username, password
    })

    return jsonApiHttpClient(`${constants.apiUrl}/login`, {
      method: 'POST',
      body: data
    }).then(response => {
      if (response && response.json && response.json.authHeader) {
        if (compareScopes(response.json.scope, APP_PERMISSIONS)) {
          // eslint-disable-next-line
          localStorage.setItem('token', response.json.authHeader)
          return Promise.resolve()
        } else {
          throw new Error('Acesso negado')
        }
      } else {
        // eslint-disable-next-line
        Promise.reject()
      }
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  if (type === AUTH_LOGOUT) {
    // eslint-disable-next-line
    localStorage.removeItem('token')
    return Promise.resolve()
  }

  if (type === AUTH_ERROR) {
    return Promise.resolve()
  }

  if (type === AUTH_CHECK) {
    // eslint-disable-next-line
    return localStorage.getItem('token') ? Promise.resolve() : Promise.reject()
  }
}



// WEBPACK FOOTER //
// ./src/services/authClient.js